import { render } from "./UnlockPeople.vue?vue&type=template&id=0a2214c6&scoped=true"
import script from "./UnlockPeople.vue?vue&type=script&lang=js"
export * from "./UnlockPeople.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2214c6"]])

export default __exports__